import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { ConfiguratorState } from 'models/configurator';
import { TablesDataColumns, TableValue } from 'models/response';

const setTablesSelectValues: CaseReducer<ConfiguratorState, PayloadAction<TableValue[]>> = (state, { payload }) => {
  state.tables.tablesSelectValues = payload;
};
const setActiveTable: CaseReducer<ConfiguratorState, PayloadAction<{ value: string; label: string } | null>> = (
  state,
  { payload },
) => {
  state.tables.activeTable = payload;
};

const setTableColumns: CaseReducer<ConfiguratorState, PayloadAction<TablesDataColumns[]>> = (state, { payload }) => {
  state.tables.tableColumns = payload;
};

const setTableRows: CaseReducer<ConfiguratorState, PayloadAction<any[]>> = (state, { payload }) => {
  state.tables.tableRows = payload;
};

const setCompanyPriv: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.tables.companyPriv = payload;
};

const setTablesSelectedRow: CaseReducer<ConfiguratorState, PayloadAction<any[]>> = (state, { payload }) => {
  state.tables.selectedRow = payload;
};

const setExternalTablesRowSelected: CaseReducer<ConfiguratorState, PayloadAction<number[]>> = (state, { payload }) => {
  state.tables.externalTablesRowSelected = payload;
};

const setTablesEditRowID: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.tables.editRowID = payload;
};

const setTableMode: CaseReducer<ConfiguratorState, PayloadAction<'edit' | 'add' | null>> = (state, { payload }) => {
  state.tables.tableMode = payload;
};

const removeTableRows: CaseReducer<ConfiguratorState, PayloadAction<number[]>> = (state, { payload }) => {
  const newRows = state.tables.tableRows.filter((row) => !payload.includes(row.idRow));
  state.tables.tableRows = newRows;
};

export default {
  setTablesSelectValues,
  setActiveTable,
  setTablesSelectedRow,
  setExternalTablesRowSelected,
  removeTableRows,
  setTableMode,
  setTablesEditRowID,
  setCompanyPriv,
  setTableColumns,
  setTableRows,
};
